const state = () => ({
  isGatedVisible: sessionStorage.getItem('isGatedVisible') === 'true',
});

const mutations = {
  SET_GATED_VISIBILITY(state, status) {
    state.isGatedVisible = status;
    sessionStorage.setItem('isGatedVisible', status);
  },
};

const actions = {
  setGatedVisibility({ commit }, status) {
    commit('SET_GATED_VISIBILITY', status);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};